import { render, staticRenderFns } from "./DocumentTaskTemplate.vue?vue&type=template&id=553acc90&scoped=true&lang=pug"
import script from "./DocumentTaskTemplate.vue?vue&type=script&lang=ts"
export * from "./DocumentTaskTemplate.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTaskTemplate.vue?vue&type=style&index=0&id=553acc90&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553acc90",
  null
  
)

export default component.exports